import { provisioningGraphsDto } from '../dto/provisioningGraphsDto';
import { OverProvisioningPoint } from '../views/overProvisioningGraphViewModel';

export class overProvisioningGraphTransformer {
  public static from(dto: provisioningGraphsDto): OverProvisioningPoint[] {
    const vms = dto.Data.VMs;
    let points: OverProvisioningPoint[] = vms.map(vm => {
      return {
        Name: vm.Name,
        ProvisionedCapacityGB: vm.ProvisionedCapacityGB,
        UsedCapacityGB: vm.UsedCapacityGB,
        ProvisionedMemoryGB: vm.ProvisionedMemoryGB,
        UsedMemoryGB: vm.UsedMemoryGB,
        ProvisionedVCpu: vm.ProvisionedVCpu,
        UsedVCpu: vm.UsedVCpu,
        PeakVCpu: vm.PeakVCpu,
        AvgVCpu: vm.AvgVCpu,
        PeakMemoryGB: vm.PeakMemoryGB,
        AvgMemoryGB: vm.AvgMemoryGB,
        value: 0
      };
    });

    return points;
  }
}
